var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsStacked01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.167a4.167 4.167 0 1 0 8.334 0 4.167 4.167 0 0 0-8.334 0zm0 0c0-.938.31-1.804.834-2.5v-7.5m-.834 10c0 .688.167 1.336.462 1.908-.702.593-2.323 1.008-4.212 1.008-2.531 0-4.583-.746-4.583-1.666V4.167m9.167 0c0 .92-2.052 1.666-4.584 1.666-2.531 0-4.583-.746-4.583-1.666m9.167 0c0-.92-2.052-1.667-4.584-1.667-2.531 0-4.583.746-4.583 1.667m0 7.5c0 .92 2.052 1.666 4.583 1.666 1.824 0 3.4-.387 4.137-.948m.447-4.468c0 .92-2.052 1.666-4.584 1.666-2.531 0-4.583-.746-4.583-1.666",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsStacked01);
export default __webpack_public_path__ + "static/media/coinsStacked01.9df1bcb24b961388fd26884672949d14.svg";
export { ForwardRef as ReactComponent };